module.exports = __webpack_public_path__ + "static/media/box-alt.aac90d8e.svg";